import { PLATFORM_PUBLIC_URL } from "@/shared/environmentVariables";

const ONBOARDING_URL = `${PLATFORM_PUBLIC_URL}/onboarding`;

export interface VerifyResponse {
  valid: boolean;
  alreadyOnboarded?: boolean;
  companyName?: string;
  fullName?: string;
  redirectPath?: string | null;
  // customToken?: string;
}

export interface ActivateResponse {
  success: boolean;
  alreadyOnboarded: boolean;
  customToken: string;
}

export async function verifyOnboarding(
  inn: string,
  kpp: string,
): Promise<VerifyResponse> {
  const response = await fetch(
    `${ONBOARDING_URL}/verify?inn=${encodeURIComponent(inn)}&kpp=${encodeURIComponent(kpp)}`,
  );

  if (!response.ok) {
    throw new Error(`Verification failed: ${response.status}`);
  }

  return response.json();
}

export async function activateOnboarding(
  inn: string,
  kpp: string,
): Promise<ActivateResponse> {
  const response = await fetch(`${ONBOARDING_URL}/activate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ inn, kpp }),
  });

  if (!response.ok) {
    throw new Error(`Activation failed: ${response.status}`);
  }

  return response.json();
}
